// Programming & IT Certification Mock Data
// 程式設計與資訊科技認證 模擬數據

export const programmingExams = [
  // JavaScript Fundamentals
  {
    id: 1,
    name: 'JavaScript 基礎認證',
    nameEn: 'JavaScript Fundamentals Certification',
    nameCn: 'JavaScript 基础认证',
    nameJa: 'JavaScript基礎認定',
    course: '網頁前端開發',
    duration: 90,
    totalQuestions: 30,
    passingScore: 70,
    category: 'programming',
    difficulty: 'beginner',
    description: '測試JavaScript基本語法、變數、函數和DOM操作知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 90, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 90, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪種方式可以正確宣告JavaScript變數？",
        questionEn: "Which of the following correctly declares a JavaScript variable?",
        options: [
          "var name = 'John';",
          "variable name = 'John';",
          "string name = 'John';",
          "declare name = 'John';"
        ],
        correctAnswer: 0,
        explanation: "在JavaScript中，使用var、let或const關鍵字來宣告變數。",
        explanationEn: "In JavaScript, use var, let, or const keywords to declare variables.",
        difficulty: "easy",
        topic: "變數宣告"
      }
      // More questions...
    ]
  },

  // HTML/CSS Web Design
  {
    id: 2,
    name: 'HTML/CSS 網頁設計',
    nameEn: 'HTML/CSS Web Design',
    nameCn: 'HTML/CSS 网页设计',
    nameJa: 'HTML/CSS ウェブデザイン',
    course: '網頁設計基礎',
    duration: 90,
    totalQuestions: 30,
    passingScore: 70,
    category: 'web-design',
    difficulty: 'beginner',
    description: '測試HTML結構、CSS樣式和響應式設計知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 90, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 90, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個HTML標籤用於創建超連結？",
        questionEn: "Which HTML tag is used to create hyperlinks?",
        options: [
          "<a>",
          "<link>",
          "<href>",
          "<url>"
        ],
        correctAnswer: 0,
        explanation: "<a>標籤（anchor）用於創建超連結，配合href屬性指定連結目標。",
        explanationEn: "The <a> tag (anchor) is used to create hyperlinks, with the href attribute specifying the link destination.",
        difficulty: "easy",
        topic: "HTML基礎"
      }
      // More questions...
    ]
  },

  // Python Programming
  {
    id: 3,
    name: 'Python 程式設計',
    nameEn: 'Python Programming',
    nameCn: 'Python 程序设计',
    nameJa: 'Python プログラミング',
    course: '程式設計基礎',
    duration: 120,
    totalQuestions: 30,
    passingScore: 70,
    category: 'programming',
    difficulty: 'intermediate',
    description: '測試Python語法、資料結構和演算法基礎知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 120, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 120, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Python中哪個關鍵字用於定義函數？",
        questionEn: "Which keyword is used to define a function in Python?",
        options: [
          "def",
          "function",
          "func",
          "define"
        ],
        correctAnswer: 0,
        explanation: "在Python中，使用def關鍵字來定義函數。",
        explanationEn: "In Python, the def keyword is used to define functions.",
        difficulty: "easy",
        topic: "函數定義"
      }
      // More questions...
    ]
  }
]; 